import { useEffect, useState } from 'react';
import { useAuth } from './use-auth';
import { useCompanyDataValidation } from './useCompanyDataValidation';

export function useRequiredCompanyData() {
  const { activeCompany, hasCompanyRole, dataLoaded } = useAuth();
  const { isValid, missingFields, company, refetch } = useCompanyDataValidation(activeCompany?.id);
  const [shouldShowModal, setShouldShowModal] = useState(false);
  const [modalDismissed, setModalDismissed] = useState(false);

  // Verificar se é company_admin
  const isCompanyAdmin = activeCompany && (
    hasCompanyRole(activeCompany.id, 'company_admin') ||
    hasCompanyRole(activeCompany.id, 'admin_company')
  );

  // Reset modalDismissed quando a empresa ativa mudar (novo login)
  useEffect(() => {
    setModalDismissed(false);
  }, [activeCompany?.id]);

  useEffect(() => {
    // Só verificar quando dados estiverem carregados
    if (!dataLoaded || !activeCompany || !isCompanyAdmin) {
      setShouldShowModal(false);
      return;
    }

    // Verificar se precisa mostrar modal (dados incompletos e modal não foi fechado)
    if (!isValid && !modalDismissed) {
      setShouldShowModal(true);
    } else {
      setShouldShowModal(false);
    }
  }, [dataLoaded, activeCompany, isCompanyAdmin, isValid, modalDismissed]);

  const handleModalClose = () => {
    // Permitir fechar o modal, mas ele reaparece no próximo login
    setModalDismissed(true);
    setShouldShowModal(false);
  };

  const handleModalSaved = () => {
    setShouldShowModal(false);
    refetch(); // Re-validar dados
  };

  return {
    shouldShowModal,
    company,
    missingFields,
    handleModalClose,
    handleModalSaved,
    isCompanyAdmin,
  };
}
